module.exports = __webpack_public_path__ + "svg/Fond-Hero-small-01c.svg";